import Chip from "@mui/material/Chip";
import { PricebookItemActivePeriod } from "../../../../types/price-book.type";
import { numberWithCommas } from "../../../../utils";
import { formatActivePeriodLabel, formatExpiringLabel } from "./periodModel";

interface LinePeriodChipsProps {
  activePeriod: PricebookItemActivePeriod | null;
  upcomingPeriodCount: number;
  /** Opens the running period for editing; absent for readers and while it cannot be written. */
  onOpenActivePeriod?: () => void;
}

/**
 * How a product row's price periods stand today: the period it sells at now (clickable to edit
 * for a writer), a warning when that period ends within the window, and how many are scheduled.
 */
export default function LinePeriodChips({
  activePeriod,
  upcomingPeriodCount,
  onOpenActivePeriod,
}: LinePeriodChipsProps) {
  return (
    <>
      {activePeriod && (
        <Chip
          size="small"
          color="secondary"
          variant="outlined"
          label={formatActivePeriodLabel(
            activePeriod.start_date,
            activePeriod.end_date,
          )}
          onClick={onOpenActivePeriod}
        />
      )}
      {activePeriod?.is_expiring && (
        <Chip
          size="small"
          color="warning"
          label={formatExpiringLabel(activePeriod.ends_in_days)}
        />
      )}
      {upcomingPeriodCount > 0 && (
        <Chip
          size="small"
          color="info"
          variant="outlined"
          label={`ช่วงล่วงหน้า ${numberWithCommas(upcomingPeriodCount)}`}
        />
      )}
    </>
  );
}
